import PropTypes from 'prop-types';

const NameValueType = PropTypes.shape({
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
});

export default NameValueType;
